<template>
  <section>
    <text-h2 class="text-center">Learn More About RNA</text-h2>
    <section-container class="mt-12">
      <div class="max-w-4xl mx-auto">
        <div class="flex justify-center mb-8">
          <img 
            src="https://regionalneurological.com/wp-content/uploads/2019/01/IMG_2048-e1547054625534-1024x480.jpg" 
            alt="Regional Neurological Associates" 
            class="max-w-full h-auto rounded-lg shadow-lg"
          />
        </div>
        <p class="text-lg leading-relaxed text-gray-700">
          Founded in 1997, RNA is one of the oldest Psychiatry & Neurology practices in the Bronx and Westchester. At our Bronx, New York practice, we specialize in diagnosing and treating all psychiatric conditions, including depression, anxiety, suicidal ideation, headaches & migraines, and more. Each patient's condition requires the expert care of the finest psychiatrists available. We take pride in providing that care. Our highly skilled board certified doctors and staff are dedicated to providing our patients with all the pertinent information about their conditions and explaining the treatment options that are available for their particular malady.
        </p>
        <p class="text-lg leading-relaxed text-gray-700 mt-6">
          Our team of dedicated professionals are committed to providing expert medical care using the latest technology and advanced training in a comfortable atmosphere. We will do everything possible to make your visit an exceptional and stress-free experience. Your psychiatric health and care is our number one concern.
        </p>
        <p class="text-lg leading-relaxed text-gray-700 mt-6 pb-[60px]">
          What distinguishes Regional Neurological Associates from other practices in the area is the advanced and extensive training of our doctors in the psychiatric and neurological subspecialities which include but are not limited to: Depression, epilepsy, pain management, and migraine headache.
        </p>
      </div>
    </section-container>
  </section>
</template>

<script setup>
// Video player functionality removed - now displays text content
</script>

<style lang="scss">
// Video styles removed - now displays text content
</style>
